var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-body"},[_c('iframe',{attrs:{"src":_vm.reportUrl,"height":"100%","width":"100%","frameborder":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }